import { ROUTER_BASENAME } from "../config/env";

const ROUTE_MARKERS = ["/widgets/", "/widgets", "/events", "/registrations", "/settings", "/plans"];

/** Build a browser URL path (includes app handle prefix when configured). */
export function appPath(pathname) {
  const p = pathname.startsWith("/") ? pathname : `/${pathname}`;
  if (!ROUTER_BASENAME) return p;
  if (p === ROUTER_BASENAME || p.startsWith(`${ROUTER_BASENAME}/`)) return p;
  return `${ROUTER_BASENAME}${p}`;
}

/**
 * Map window.location.pathname (Shopify admin / app handle prefixes) to a React Router path.
 */
export function toRouterPath(pathname) {
  if (!pathname) return "/";
  let path = pathname;

  const base = ROUTER_BASENAME;
  if (base) {
    if (path === base || path === `${base}/`) return "/";
    if (path.startsWith(`${base}/`)) {
      path = path.slice(base.length);
      return path.startsWith("/") ? path : `/${path}`;
    }
  }

  const widgetEdit = path.match(/\/widgets\/([^/]+)\/edit\/?$/);
  if (widgetEdit) {
    return `/widgets/${decodeURIComponent(widgetEdit[1])}/edit`;
  }
  const widgetNew = path.match(/\/widgets\/new\/?$/);
  if (widgetNew) {
    return "/widgets/new";
  }

  let bestIndex = -1;
  for (const marker of ROUTE_MARKERS) {
    const i = path.indexOf(marker);
    if (i >= 0 && (bestIndex < 0 || i < bestIndex)) bestIndex = i;
  }
  if (bestIndex >= 0) {
    path = path.slice(bestIndex);
  }

  return path.startsWith("/") ? path : `/${path}`;
}
